export const CURRENCY_EUR = 'EUR';
export const CURRENCY_USD = 'USD';
export const CURRENCY_CRD = 'CREDITS';

export const availableCurrencies = [
  CURRENCY_EUR,
  CURRENCY_USD,
  CURRENCY_CRD,
];

export const currencySignMap = {
  [CURRENCY_EUR]: '€',
  [CURRENCY_USD]: '$',
  [CURRENCY_CRD]: 'CRD',
};
